// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const runerigus: PokeData = {
  "id": 867,
  "name": "runerigus",
  "height": 16,
  "weight": 666,
  "base_experience": 169,
  "types": [
    PokeType.GROUND,
    PokeType.GHOST
  ],
  "api_moves": [
    "slam",
    "disable",
    "earthquake",
    "night-shade",
    "haze",
    "curse",
    "protect",
    "scary-face",
    "destiny-bond",
    "mean-look",
    "shadow-ball",
    "astonish",
    "shadow-claw",
    "guard-split",
    "power-split",
    "hex",
    "crafty-shield",
    "brutal-swing"
  ],
  "moves": [
    "earthquake",
    "night-shade",
    "curse",
    "protect",
    "scary-face",
    "shadow-ball",
    "earth-power",
    "shadow-sneak",
    "rototiller",
    "bonemerang",
    "fissure",
    "mud-slap",
    "sandstorm"
  ],
  "evolution_chain": {
    "id": 287,
    "item": null,
    "species": [
      {
        "name": "yamask",
        "order": 563,
        "types": [
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "cofagrigus",
        "order": 564,
        "types": [
          PokeType.GHOST
        ],
        "evolves_from_species_id": 562,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 34,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "runerigus",
        "order": 867,
        "types": [
          PokeType.GROUND,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 562,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TAKE_DAMAGE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 169,
    "speed": 55,
    "ability_power": 176
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
